export interface Province {
  province: Array<{
  id: number,
  code: string,
  text: string,
  value: string,
  name: {
    th: string,
    en: string,
    },
  geographyId: number,
  }>
}

export function getProvince(): Province {
  return {
    province: [
      {
        id: 1,
        code: '10',
        text: 'กรุงเทพมหานคร',
        value: 'กรุงเทพมหานคร',
        name: {
          th: 'กรุงเทพมหานคร',
          en: 'Bangkok',
        },
        geographyId: 2,
      },
      {
        id: 2,
        code: '11',
        text: 'สมุทรปราการ',
        value: 'สมุทรปราการ',
        name: {
          th: 'สมุทรปราการ',
          en: 'Samut Prakan',
        },
        geographyId: 2,
      },
      {
        id: 3,
        code: '12',
        text: 'นนทบุรี',
        value: 'นนทบุรี',
        name: {
          th: 'นนทบุรี',
          en: 'Non thaburi',
        },
        geographyId: 2,
      },
      {
        id: 4,
        code: '13',
        text: 'ปทุมธานี',
        value: 'ปทุมธานี',
        name: {
          th: 'ปทุมธานี',
          en: 'Pa thum  thani',
        },
        geographyId: 2,
      },
      {
        id: 5,
        code: '14',
        text: 'พระนครศรีอยุธยา',
        value: 'พระนครศรีอยุธยา',
        name: {
          th: 'พระนครศรีอยุธยา',
          en: 'Phra Nakhon Si Ayut thaya',
        },
        geographyId: 2,
      },
      {
        id: 6,
        code: '15',
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang  thong',
        },
        geographyId: 2,
      },
      {
         id: 7,
         code: '16',
         text: 'ลพบุรี',
         value: 'ลพบุรี',
         name: {
           th: 'ลพบุรี',
           en: 'Loburi',
         },
         geographyId: 2,
      },
      {
        id: 8,
        code: '17',
        text: 'สิงห์บุรี',
        value: 'สิงห์บุรี',
        name: {
          th: 'สิงห์บุรี',
          en: 'Sing Buri',
        },
        geographyId: 2,
      },
      {
        id: 9,
        code: '18',
        text: 'ชัยนาท',
        value: 'ชัยนาท',
        name: {
          th: 'ชัยนาท',
          en: 'Chai Nat',
        },
        geographyId: 2,
      },
      {
        id: 10,
        code: '19',
        text: 'สระบุรี',
        value: 'สระบุรี',
        name: {
          th: 'สระบุรี',
          en: 'Saraburi',
        },
        geographyId: 2,
      },
      {
        id: 11,
        code: '20',
        text: 'ชลบุรี',
        value: 'ชลบุรี',
        name: {
          th: 'ชลบุรี',
          en: 'Chon Buri',
        },
        geographyId: 5,
      },
      {
        id: 12,
        code: '21',
        text: 'ระยอง',
        value: 'ระยอง',
        name: {
          th: 'ระยอง',
          en: 'Rayong',
        },
        geographyId: 5,
      },
      {
        id: 13,
        code: '22',
        text: 'จันทบุรี',
        value: 'จันทบุรี',
        name: {
          th: 'จันทบุรี',
          en: 'Chan thaburi',
        },
        geographyId: 5,
      },
      {
        id: 14,
        code: '23',
        text: 'ตราด',
        value: 'ตราด',
        name: {
          th: 'ตราด',
          en: 'Trat',
        },
        geographyId: 5,
      },
      {
        id: 15,
        code: '24',
        text: 'ฉะเชิงเทรา',
        value: 'ฉะเชิงเทรา',
        name: {
          th: 'ฉะเชิงเทรา',
          en: 'Chacho engsao',
        },
        geographyId: 5,
      },
      {
        id: 16,
        code: '25',
        text: 'ปราจีนบุรี',
        value: 'ปราจีนบุรี',
        name: {
          th: 'ปราจีนบุรี',
          en: 'Prachin Buri',
        },
        geographyId: 5,
      },
      {
        id: 17,
        code: '26',
        text: 'นครนายก',
        value: 'นครนายก',
        name: {
          th: 'นครนายก',
          en: 'Nakhon Nayok',
        },
        geographyId: 2,
      },
      {
         id: 18,
         code: '27',
         text: 'สระแก้ว',
         value: 'สระแก้ว',
         name: {
           th: 'สระแก้ว',
           en: 'Sa Kaeo',
         },
         geographyId: 5,
      },
      {
         id: 19,
         code: '30',
         text: 'นครราชสีมา',
         value: 'นครราชสีมา',
         name: {
           th: 'นครราชสีมา',
           en: 'Nakhon Ratchasima',
         },
         geographyId: 3,
      },
      {
         id: 20,
         code: '31',
         text: 'บุรีรัมย์',
         value: 'บุรีรัมย์',
         name: {
           th: 'บุรีรัมย์',
           en: 'Buri Ram',
         },
         geographyId: 3,
      },
      {
         id: 21,
         code: '32',
         text: 'สุรินทร์',
         value: 'สุรินทร์',
         name: {
           th: 'สุรินทร์',
           en: 'Surin',
         },
         geographyId: 3,
      },
      {
         id: 22,
         code: '33',
         text: 'ศรีสะเกษ',
         value: 'ศรีสะเกษ',
         name: {
           th: 'ศรีสะเกษ',
           en: 'Si Sa Ket',
         },
         geographyId: 3,
      },
      {
         id: 23,
         code: '34',
         text: 'อุบลราชธานี',
         value: 'อุบลราชธานี',
         name: {
           th: 'อุบลราชธานี',
           en: 'Ubon Ratcha thani',
         },
         geographyId: 3,
      },
      {
         id: 24,
         code: '35',
         text: 'ยโสธร',
         value: 'ยโสธร',
         name: {
           th: 'ยโสธร',
           en: 'Yaso thon',
         },
         geographyId: 3,
      },
      {
         id: 25,
         code: '36',
         text: 'ชัยภูมิ',
         value: 'ชัยภูมิ',
         name: {
           th: 'ชัยภูมิ',
           en: 'Chaiyaphum',
         },
         geographyId: 3,
      },
      {
         id: 26,
         code: '37',
         text: 'อำนาจเจริญ',
         value: 'อำนาจเจริญ',
         name: {
           th: 'อำนาจเจริญ',
           en: 'Amnat Charo en',
         },
         geographyId: 3,
      },
      {
         id: 27,
         code: '39',
         text: 'หนองบัวลำภู',
         value: 'หนองบัวลำภู',
         name: {
           th: 'หนองบัวลำภู',
           en: 'Nong Bua Lam Phu',
         },
         geographyId: 3,
      },
      {
         id: 28,
         code: '40',
         text: 'ขอนแก่น',
         value: 'ขอนแก่น',
         name: {
           th: 'ขอนแก่น',
           en: 'Khon Ka en',
         },
         geographyId: 3,
      },
      {
         id: 29,
         code: '41',
         text: 'อุดรธานี',
         value: 'อุดรธานี',
         name: {
           th: 'อุดรธานี',
           en: 'Udon  thani',
         },
         geographyId: 3,
      },
      {
         id: 30,
         code: '42',
         text: 'เลย',
         value: 'เลย',
         name: {
           th: 'เลย',
           en: 'Loei',
         },
         geographyId: 3,
      },
      {
         id: 31,
         code: '43',
         text: 'หนองคาย',
         value: 'หนองคาย',
         name: {
           th: 'หนองคาย',
           en: 'Nong Khai',
         },
         geographyId: 3,
      },
      {
         id: 32,
         code: '44',
         text: 'มหาสารคาม',
         value: 'มหาสารคาม',
         name: {
           th: 'มหาสารคาม',
           en: 'Maha Sarakham',
         },
         geographyId: 3,
      },
      {
         id: 33,
         code: '45',
         text: 'ร้อยเอ็ด',
         value: 'ร้อยเอ็ด',
         name: {
           th: 'ร้อยเอ็ด',
           en: 'Roi Et',
         },
         geographyId: 3,
      },
      {
         id: 34,
         code: '46',
         text: 'กาฬสินธุ์',
         value: 'กาฬสินธุ์',
         name: {
           th: 'กาฬสินธุ์',
           en: 'Kalasin',
         },
         geographyId: 3,
      },
      {
         id: 35,
         code: '47',
         text: 'สกลนคร',
         value: 'สกลนคร',
         name: {
           th: 'สกลนคร',
           en: 'Sakon Nakhon',
         },
         geographyId: 3,
      },
      {
         id: 36,
         code: '48',
         text: 'นครพนม',
         value: 'นครพนม',
         name: {
           th: 'นครพนม',
           en: 'Nakhon Phanom',
         },
         geographyId: 3,
      },
      {
         id: 37,
         code: '49',
         text: 'มุกดาหาร',
         value: 'มุกดาหาร',
         name: {
           th: 'มุกดาหาร',
           en: 'Mukdahan',
         },
         geographyId: 3,
      },
      {
         id: 38,
         code: '50',
         text: 'เชียงใหม่',
         value: 'เชียงใหม่',
         name: {
           th: 'เชียงใหม่',
           en: 'Chiang Mai',
         },
         geographyId: 1,
      },
      {
         id: 39,
         code: '51',
         text: 'ลำพูน',
         value: 'ลำพูน',
         name: {
           th: 'ลำพูน',
           en: 'Lamphun',
         },
         geographyId: 1,
      },
      {
         id: 40,
         code: '52',
         text: 'ลำปาง',
         value: 'ลำปาง',
         name: {
           th: 'ลำปาง',
           en: 'Lampang',
         },
         geographyId: 1,
      },
      {
         id: 41,
         code: '53',
         text: 'อุตรดิตถ์',
         value: 'อุตรดิตถ์',
         name: {
           th: 'อุตรดิตถ์',
           en: 'Uttaradit',
         },
         geographyId: 1,
      },
      {
         id: 42,
         code: '54',
         text: 'แพร่',
         value: 'แพร่',
         name: {
           th: 'แพร่',
           en: 'Phrae',
         },
         geographyId: 1,
      },
      {
         id: 43,
         code: '55',
         text: 'น่าน',
         value: 'น่าน',
         name: {
           th: 'น่าน',
           en: 'Nan',
         },
         geographyId: 1,
      },
      {
         id: 44,
         code: '56',
         text: 'พะเยา',
         value: 'พะเยา',
         name: {
           th: 'พะเยา',
           en: 'Phayao',
         },
         geographyId: 1,
      },
      {
         id: 45,
         code: '57',
         text: 'เชียงราย',
         value: 'เชียงราย',
         name: {
           th: 'เชียงราย',
           en: 'Chiang Rai',
         },
         geographyId: 1,
      },
      {
         id: 46,
         code: '58',
         text: 'แม่ฮ่องสอน',
         value: 'แม่ฮ่องสอน',
         name: {
           th: 'แม่ฮ่องสอน',
           en: 'Mae Hong Son',
         },
         geographyId: 1,
      },
      {
         id: 47,
         code: '60',
         text: 'นครสวรรค์',
         value: 'นครสวรรค์',
         name: {
           th: 'นครสวรรค์',
           en: 'Nakhon Sawan',
         },
         geographyId: 2,
      },
      {
         id: 48,
         code: '61',
         text: 'อุทัยธานี',
         value: 'อุทัยธานี',
         name: {
           th: 'อุทัยธานี',
           en: 'U thai  thani',
         },
         geographyId: 2,
      },
      {
         id: 49,
         code: '62',
         text: 'กำแพงเพชร',
         value: 'กำแพงเพชร',
         name: {
           th: 'กำแพงเพชร',
           en: 'Kampha eng Phet',
         },
         geographyId: 2,
      },
      {
         id: 50,
         code: '63',
         text: 'ตาก',
         value: 'ตาก',
         name: {
           th: 'ตาก',
           en: 'Tak',
         },
         geographyId: 4,
      },
      {
         id: 51,
         code: '64',
         text: 'สุโขทัย',
         value: 'สุโขทัย',
         name: {
           th: 'สุโขทัย',
           en: 'Sukho thai',
         },
         geographyId: 2,
      },
      {
         id: 52,
         code: '65',
         text: 'พิษณุโลก',
         value: 'พิษณุโลก',
         name: {
           th: 'พิษณุโลก',
           en: 'Phitsanulok',
         },
         geographyId: 2,
      },
      {
         id: 53,
         code: '66',
         text: 'พิจิตร',
         value: 'พิจิตร',
         name: {
           th: 'พิจิตร',
           en: 'Phichit',
         },
         geographyId: 2,
      },
      {
         id: 54,
         code: '67',
         text: 'เพชรบูรณ์',
         value: 'เพชรบูรณ์',
         name: {
           th: 'เพชรบูรณ์',
           en: 'Phetchabun',
         },
         geographyId: 2,
      },
      {
         id: 55,
         code: '70',
         text: 'ราชบุรี',
         value: 'ราชบุรี',
         name: {
           th: 'ราชบุรี',
           en: 'Ratchaburi',
         },
         geographyId: 4,
      },
      {
         id: 56,
         code: '71',
         text: 'กาญจนบุรี',
         value: 'กาญจนบุรี',
         name: {
           th: 'กาญจนบุรี',
           en: 'Kanchanaburi',
         },
         geographyId: 4,
      },
      {
         id: 57,
         code: '72',
         text: 'สุพรรณบุรี',
         value: 'สุพรรณบุรี',
         name: {
           th: 'สุพรรณบุรี',
           en: 'Suphan Buri',
         },
         geographyId: 2,
      },
      {
         id: 58,
         code: '73',
         text: 'นครปฐม',
         value: 'นครปฐม',
         name: {
           th: 'นครปฐม',
           en: 'Nakhon Pa thom',
         },
         geographyId: 2,
      },
      {
         id: 59,
         code: '74',
         text: 'สมุทรสาคร',
         value: 'สมุทรสาคร',
         name: {
           th: 'สมุทรสาคร',
           en: 'Samut Sakhon',
         },
         geographyId: 2,
      },
      {
         id: 60,
         code: '75',
         text: 'สมุทรสงคราม',
         value: 'สมุทรสงคราม',
         name: {
           th: 'สมุทรสงคราม',
           en: 'Samut Songkhram',
         },
         geographyId: 2,
      },
      {
         id: 61,
         code: '76',
         text: 'เพชรบุรี',
         value: 'เพชรบุรี',
         name: {
           th: 'เพชรบุรี',
           en: 'Phetchaburi',
         },
         geographyId: 4,
      },
      {
         id: 62,
         code: '77',
         text: 'ประจวบคีรีขันธ์',
         value: 'ประจวบคีรีขันธ์',
         name: {
           th: 'ประจวบคีรีขันธ์',
           en: 'Prachuap Khiri Khan',
         },
         geographyId: 4,
      },
      {
         id: 63,
         code: '80',
         text: 'นครศรีธรรมราช',
         value: 'นครศรีธรรมราช',
         name: {
           th: 'นครศรีธรรมราช',
           en: 'Nakhon Si  thammarat',
         },
         geographyId: 6,
      },
      {
         id: 64,
         code: '81',
         text: 'กระบี่',
         value: 'กระบี่',
         name: {
           th: 'กระบี่',
           en: 'Krabi',
         },
         geographyId: 6,
      },
      {
         id: 65,
         code: '82',
         text: 'พังงา',
         value: 'พังงา',
         name: {
           th: 'พังงา',
           en: 'Phangnga',
         },
         geographyId: 6,
      },
      {
         id: 66,
         code: '83',
         text: 'ภูเก็ต',
         value: 'ภูเก็ต',
         name: {
           th: 'ภูเก็ต',
           en: 'Phuket',
         },
         geographyId: 6,
      },
      {
         id: 67,
         code: '84',
         text: 'สุราษฎร์ธานี',
         value: 'สุราษฎร์ธานี',
         name: {
           th: 'สุราษฎร์ธานี',
           en: 'Surat  thani',
         },
         geographyId: 6,
      },
      {
         id: 68,
         code: '85',
         text: 'ระนอง',
         value: 'ระนอง',
         name: {
           th: 'ระนอง',
           en: 'Ranong',
         },
         geographyId: 6,
      },
      {
         id: 69,
         code: '86',
         text: 'ชุมพร',
         value: 'ชุมพร',
         name: {
           th: 'ชุมพร',
           en: 'Chumphon',
         },
         geographyId: 6,
      },
      {
         id: 70,
         code: '90',
         text: 'สงขลา',
         value: 'สงขลา',
         name: {
           th: 'สงขลา',
           en: 'Songkhla',
         },
         geographyId: 6,
      },
      {
         id: 71,
         code: '91',
         text: 'สตูล',
         value: 'สตูล',
         name: {
           th: 'สตูล',
           en: 'Satun',
         },
         geographyId: 6,
      },
      {
         id: 72,
         code: '92',
         text: 'ตรัง',
         value: 'ตรัง',
         name: {
           th: 'ตรัง',
           en: 'Trang',
         },
         geographyId: 6,
      },
      {
         id: 73,
         code: '93',
         text: 'พัทลุง',
         value: 'พัทลุง',
         name: {
           th: 'พัทลุง',
           en: 'Phat thalung',
         },
         geographyId: 6,
      },
      {
         id: 74,
         code: '94',
         text: 'ปัตตานี',
         value: 'ปัตตานี',
         name: {
           th: 'ปัตตานี',
           en: 'Pattani',
         },
         geographyId: 6,
      },
      {
         id: 75,
         code: '95',
         text: 'ยะลา',
         value: 'ยะลา',
         name: {
           th: 'ยะลา',
           en: 'Yala',
         },
         geographyId: 6,
      },
      {
         id: 76,
         code: '96',
         text: 'นราธิวาส',
         value: 'นราธิวาส',
         name: {
           th: 'นราธิวาส',
           en: 'Nara thiwat',
         },
         geographyId: 6,
      },
      {
         id: 77,
         code: '97',
         text: 'บึงกาฬ',
         value: 'บึงกาฬ',
         name: {
           th: 'บึงกาฬ',
           en: 'buogkan',
         },
         geographyId: 3,
       },
    ],
  }
}
